import { errorMessages, urlGenerator } from "app";
import { getToken, refreshToken } from "auth/dataProvider.utils";
import { HttpError } from "react-admin";
import { idFileGenerate } from "utils/validations";

export const customFile = async (url, data, method = "GET", params, useFormData = false) => {
  params ? (url = `${urlGenerator(url)}${params}`) : (url = `${urlGenerator(url)}`);

  return fetchJson({
    url,
    method,
    data,
    params: {
      meta: { useFormData: useFormData },
    },
  }).then(response => {
    return { data: response.json || response.body };
  });
};

const fetchJson = async ({ url, method, data, params, isOtherFile = false }) => {
  let options = {
    method: method,
    headers: {
      "X-Session-Id": getToken(),
    },
  };

  if (data) {
    const fileFormData = new FormData();
    Object.keys(data).forEach(key => {
      if (key !== "name") fileFormData.append(`${key}`, data[key]);
    });
    if (data.name) {
      const customName = `file-${idFileGenerate()}`;
      fileFormData.append(data.name, customName);
    }
    options.body = fileFormData;
  }
  return fetch(url, options)
    .then(response =>
      response.text().then(text => ({
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        body: text,
      })),
    )
    .then(({ status, statusText, headers, body, response }) => {
      let json;
      try {
        json = JSON.parse(body);
      } catch (e) {}
      if (status === 401) {
        return refreshToken({
          callback: () => fetchJson({ url, method, data, params }),
        });
      }

      if (status < 200 || status >= 300) {
        if (json.ErrorCode || json.errorCode) {
          let errorResponse;

          if (json?.Properties?.length > 0) {
            return Promise.reject(json);
          } else {
            if (errorMessages[json?.errorCode]) {
              errorResponse = errorMessages[json?.errorCode];
            } else {
              if (process.env.NODE_ENV === "development") {
                errorResponse = json.errorCode;
              } else {
                errorResponse = errorMessages.default;
              }
            }

            return Promise.reject(new HttpError(errorResponse, status, json));
          }
        }

        return Promise.reject(new HttpError((json && json.message) || statusText, status, json));
      }
      return Promise.resolve({ status, headers, body, json });
    });
};
